// extracted by mini-css-extract-plugin
export default {"joiningHearts":"joiningHearts__NDQxZ","loader":"loader__OWU4Z","petal":"petal__MzNkM","spin":"spin__MWRkN"};